export interface PayinPaymentSwitchingRequest {
    payinActive: string;
    payoutActive: string;
}
